import React from 'react';
import {
  FaLink, FaFileExcel, FaFilePdf, FaFileWord,
  FaFilePowerpoint, FaBook, FaFileImage, FaFileVideo,
} from 'react-icons/fa';

const guideTypes = {
  x: { Icon: FaFileExcel, color: '#ffffff', label: 'Excel' },
  b: { Icon: FaFilePdf, color: '#ffffff', label: 'PDF' },
  w: { Icon: FaFileWord, color: '#ffffff', label: 'Word' },
  p: { Icon: FaFilePowerpoint, color: '#ffffff', label: 'PowerPoint' },
  o: { Icon: FaBook, color: '#ffffff', label: 'OneNote' },
  i: { Icon: FaFileImage, color: 'inherit', label: 'image' },
  v: { Icon: FaFileVideo, color: 'inherit', label: 'video' },
};
const fallback = { Icon: FaLink, color: 'inherit', label: 'external link' };

export function getGuideType(url) {
  try {
    const marker = /^\/:([a-z]):\//i.exec(new URL(url).pathname);
    return guideTypes[marker?.[1].toLowerCase()] || fallback;
  } catch {
    return fallback;
  }
}

// The API validates the destination. Classification here only chooses the icon.
export default function GuideExternalLink({ url, className, style }) {
  if (!url) return null;
  const { Icon, color, label } = getGuideType(url);
  const title = `Open guide (${label}) in a new tab`;
  return (
    <a
      className={className}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      title={title}
      aria-label={title}
      style={{ marginLeft: '8px', color, display: 'inline-flex', alignItems: 'center', ...style }}
      onClick={event => event.stopPropagation()}
    >
      <Icon size={16} aria-hidden="true" />
    </a>
  );
}
